var Tools = require('../../deploynaut/js/tools.jsx');
var Metrics = require('./Metrics.jsx');

Tools.install(Metrics, 'Metrics');

